import {
  moneyFormatter,
  primaryOwnerFormatter,
  productTypeFormatter,
  retirementAccountFormatter,
  personalInvestmentFormatter,
  collegeSavingsPlanFormatter,
  alaska529PlanFormatter
} from 'services/TableUtils';

export const defaultColDef = {
  sortable: true,
  suppressMenu: true,
  suppressMovable: true,
  aggFunc: 'sum',
  minWidth: 89
};

export const autoGroupColumnDef = {
  headerName: '',
  field: 'accountNameAndNumber',
  pinned: 'left',
  minWidth: 340,
  maxWidth: 340,
  sort: 'asc',
  cellClass: 'pinned-cell-align',
  autoHeight: true,
  resizable: true,
  cellRendererParams: {
    suppressCount: true,
    suppressDoubleClickExpand: true,
    suppressEnterExpand: true,
    suppressPadding: true,
    innerRenderer: 'accountNameRenderer'
  }
};

export const autoGroupColumnDefMobile = {
  headerName: '',
  field: 'accountNameAndNumber',
  wrapText: true,
  autoHeight: true,
  minWidth: 224,
  maxWidth: 224,
  width: 224,
  sort: 'asc',
  suppressSizeToFit: true,
  cellClass: 'pinned-cell-align lock-pinned',
  rowGroupIndex: 4,
  cellRendererParams: {
    suppressCount: true,
    suppressDoubleClickExpand: true,
    suppressEnterExpand: true,
    suppressPadding: true,
    innerRenderer: 'accountNameRenderer'
  }
};

export function ColumnDefFactory(
  retirement = false,
  has529Only = false,
  hasAlaska529Only = false
) {
  this.createColumnDef = (key) => {
    let def;

    if (isRowGroup(key)) {
      def = new RowGroupCol(key, retirement, has529Only, hasAlaska529Only);
    } else if (isRegCol(key)) {
      def = new RegCol(key);
    } else {
      def = new HiddenCol();
    }

    def.field = key;

    return def;
  };
}

const isRowGroup = (key) => {
  return (
    key === 'personalInvestment' ||
    key === 'retirementAccount' ||
    key === 'typeAndOwners' ||
    key === 'productType'
  );
};

const isRegCol = (key) => {
  return (
    key === 'beginningMarketValue' ||
    key === 'additions' ||
    key === 'deductions' ||
    key === 'income' ||
    key === 'adjustments' ||
    key === 'marketFluctuation' ||
    key === 'endingMarketValue'
  );
};

const orderedRowGroups = [
  'personalInvestment',
  'productType',
  'retirementAccount',
  'isOwner',
  'typeAndOwners'
];
const orderedRetirementRowGroups = [
  'retirementAccount',
  'productType',
  'isOwner',
  'typeAndOwners'
];

const RowGroupCol = function (key, retirement, has529Only, hasAlaska529Only) {
  this.headerName = '';
  this.rowGroup = true;
  this.hide = true;
  this.cellClass = 'pinned-cell-align';
  this.rowGroupIndex = retirement
    ? orderedRetirementRowGroups.indexOf(key)
    : orderedRowGroups.indexOf(key);

  if (key === 'personalInvestment') {
    this.valueFormatter = has529Only
      ? hasAlaska529Only
        ? alaska529PlanFormatter
        : collegeSavingsPlanFormatter
      : personalInvestmentFormatter;
  }

  if (key === 'retirementAccount') {
    this.valueFormatter = retirementAccountFormatter;
  }

  if (key === 'productType') {
    this.valueFormatter = productTypeFormatter;
  }

  if (key === 'typeAndOwners') {
    this.valueFormatter = primaryOwnerFormatter;
  }
};

const HiddenCol = function () {
  this.hide = true;
};

const RegCol = function (key) {
  this.valueFormatter = moneyFormatter;

  if (key === 'beginningMarketValue') {
    this.headerName = 'Beginning Value';
  }

  if (key === 'endingMarketValue') {
    this.headerName = 'Ending Value';
  }

  if (key === 'marketFluctuation') {
    this.cellRenderer = 'marketFluctuationRenderer';
  }

  if (key === 'adjustments') {
    this.cellRenderer = 'adjustmentsRenderer';
    this.headerComponentParams = { template: activityAdjustmentsHeaderTemplate };
  }
};

const activityAdjustmentsHeaderTemplate = `<div class="ag-cell-label-container" role="presentation">
    <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span>
    <div ref="eLabel" class="ag-header-cell-label" role="presentation">
      <Fragment>
        <span class="ag-header-cell-text">
          Adjustments <i class="aa-question-circle modal-info-icon"
            onclick={{event.stopPropagation()}}
            onmousedown={{document.body.querySelector('div.activity-adjustments-disclosure').querySelector('a.modal-info-link').click()}}
            ontouchstart={{event.stopPropagation()}}
            ontouchend={{document.body.querySelector('div.activity-adjustments-disclosure').querySelector('a.modal-info-link').click()}}
          ></i>
        </span>
        <br />
      </Fragment>
      <span ref="eSortOrder" class="ag-header-icon ag-sort-order" ></span>
      <span ref="eSortAsc" class="ag-header-icon ag-sort-ascending-icon" ></span>
      <span ref="eSortDesc" class="ag-header-icon ag-sort-descending-icon" ></span>
      <span ref="eSortNone" class="ag-header-icon ag-sort-none-icon" ></span>
    </div>
  </div>`;